import { useEffect } from 'react';
import { MonacoProviders } from '@deephaven/console';
import { useAppSelector } from '@deephaven/dashboard';
import { getNotebookSettings } from '@deephaven/redux';

/**
 * Hook to configure Ruff settings in Monaco.
 * The enabled status and settings are read from redux.
 * Any changes to the redux values will be applied to the Monaco providers.
 */
export function useConfigureRuff() {
  var _useAppSelector = useAppSelector(getNotebookSettings),
    _useAppSelector$pytho = _useAppSelector.python,
    _useAppSelector$pytho2 = _useAppSelector$pytho === void 0 ? {} : _useAppSelector$pytho,
    _useAppSelector$pytho3 = _useAppSelector$pytho2.linter,
    linter = _useAppSelector$pytho3 === void 0 ? {} : _useAppSelector$pytho3;
  var _linter$isEnabled = linter.isEnabled,
    ruffEnabled = _linter$isEnabled === void 0 ? false : _linter$isEnabled,
    ruffConfig = linter.config;
  useEffect(function setRuffSettings() {
    MonacoProviders.isRuffEnabled = ruffEnabled;
    MonacoProviders.setRuffSettings(ruffConfig); // Also inits Ruff if needed
  }, [ruffEnabled, ruffConfig]);
}
export default useConfigureRuff;
//# sourceMappingURL=useConfigureRuff.js.map